import { render, staticRenderFns } from "./ClaimBalanceCard.vue?vue&type=template&id=1b7e0d40&"
import script from "./ClaimBalanceCard.vue?vue&type=script&lang=js&"
export * from "./ClaimBalanceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports